export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6596.7b29bec7.jpg";